(function (ws) {
    'use strict';
    ws.views.savedCartListTable = ws.views.simpleTable.extend({
        /**
         * Initialize override
         */
        initialize: function() {
            this.controlColumn = 0;
            this.$table = $('#saved-carts-list');
            this.paginateUrl = globals.path.api.westcon.savedCartsTablePaginateUrl;
            this.rowTemplate = $('#savedcarts-table-row');
            ws.views.simpleTable.prototype.initialize.call(this);
        }
    });
})(westcon);
